import { Navigation } from "@/components/public/layout/Navigation"
import EventInformation from "@/components/public/EventInformation"
import { Footer } from "@/components/public/layout/Footer"
import FloatingMenu from "@/components/public/FloatingMenu"

export default function EventInfoPage() {
    return (
        <div className="min-h-screen bg-background dark:bg-gray-900">
            <Navigation />
            <EventInformation />
            <Footer />
            <FloatingMenu />
        </div>
    )
}
